<template>
  <div class="address-control">
    <div class="input-group mt10" >
    <div class="input-group-addon"><i class="fas fa-compass"></i></div>

    <google-autocomplete
        :class = "'form-control'"
        input_id = "txtAutocomplete"
        :config = "{type: ['geocode']}"
        :placeholder="'Set your address'|translate"
        v-if="!address"
    >
    </google-autocomplete>
        <p class="selected-address" v-if="address">
        <span>{{address}}</span>
        <i v-on:click="onAddressCleared" class="fas fa-times"></i>
        </p>
    </div>
    <a v-on:click="getMyLocation" >{{'Get Your Location'|translate}}</a>
  </div>
</template>
<script>
// http://farmbook.com/API/listProduct
import Utils from '@/helpers/utils'
import VueGoogleAutocomplete from 'vue-google-autocomplete'
export default {
  name: 'AddressControl',
  components: {
    VueGoogleAutocomplete
  },
  props: ['getcurrentLocation', 'initaddress' ],
  data () {
    return {
      address: '',
      lat: null,
      lng: null
    }
  },
  created () {
    if (this.initaddress) {
      console.log('this.initaddress', this.initaddress)
      for (let key in this.initaddress) {
        this[key] = this.initaddress[key]
      }
    }
    if (this.getcurrentLocation) {
      this.getMyLocation()
    }
  },
  methods: {
    onAddressChanged (payload) {
      if (payload.response.formatted_address && payload.response.geometry && payload.response.geometry.location) {
        this.address = payload.response.formatted_address
        console.log('pay load', payload, payload.response.formatted_address)
        let location = payload.response.geometry.location
        this.lat = location.lat()
        this.lng = location.lng()
        this.emitChange()
      }
    },

    onAddressCleared () {
      this.address = ''
      this.lat = null
      this.lng = null
      this.emitChange()
    },
    emitChange () {
      this.$emit('changeAddress', {
        address: this.address,
        lat: this.lat,
        lng: this.lng
      })
    },
    getMyLocation () {
      if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition(this.showPosition)
      }
    },
    showPosition (position) {
      Utils.addressFromLatLng(position.coords.latitude, position.coords.longitude).then(address => {
        this.lat = position.coords.latitude
        this.lng = position.coords.longitude
        this.address = address.address
        this.emitChange()
      })
    }
  },
  mounted () {
    Vuemit.listen('setAddress', this.onAddressChanged)
    Vuemit.listen('addressWasCleared', this.onAddressCleared)
  },
  beforeDestroy () {
    Vuemit.removeAll()
  }
}
</script>



// WEBPACK FOOTER //
// src/components/elements/AddressControl.vue